import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { publishQueryKeys } from './publishQueryKeys.js';
import { useWoody } from '../../woody/woody.js';
import { getErrorStatus } from '../../errors/errors.utils.js';
import { isQueryEnabled } from '@fabric-app/queries/utilities';

const useQueryResourcePublishDetails = (resourceId, args) => {
  const { client } = useWoody();
  const enabled = args?.enabled ?? true;
  return useQuery({
    queryKey: publishQueryKeys.resourcePublishDetails(resourceId),
    queryFn: async () => {
      return client.v2({
        endpoint: "/v2/resources/{resourceId}/publish",
        params: {
          resourceId
        }
      }).catch((e) => {
        if (getErrorStatus(e) === 404) {
          return null;
        }
        throw e;
      });
    },
    placeholderData: keepPreviousData,
    select: (data) => {
      if (!data) return data;
      const url = new URL(`/p/${data.slug}-${data.accessToken}`, typeof window !== "undefined" ? window.location.origin : "");
      return {
        ...data,
        url: url.toString()
      };
    },
    enabled: isQueryEnabled([
      enabled,
      !!resourceId
    ])
  });
};

export { useQueryResourcePublishDetails };
//# sourceMappingURL=useQueryResourcePublishDetails.js.map
